module.exports = __webpack_public_path__ + "static/matangi.6d82e4d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/matangi.jpg
// module id = 904
// module chunks = 118785002076118